import { Injectable } from '@angular/core';

/**
 * Serviço de acesso ao LocalStorage do browser.
 */
@Injectable()
export class LocalStorageService {

  /**
   * Recupera um valor armazenado no LocalStorage através de sua chave. Caso não seja encontrado, retorna null.
   *
   * @param key chave referente ao valor a ser recuperado
   * @return o objeto caso exista associação no LocalStorage e null, caso contrário
   */
  getItem(key: string): any {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  /**
   * Armazena um valor no LocalStorage utilizando a chave passada.
   *
   * @param key chave para o valor a ser armazenado
   * @param item valor a ser armazenado
   */
  setItem(key: string, item: any): void {
    localStorage.setItem(key, typeof item === 'string' ? item : JSON.stringify(item));
  }

  /**
   * Determina se a chave passada possui um valor associado no LocalStorage.
   *
   * @param key chave a ser verificada
   * @return true caso exista valor para a chave e false, caso contrário
   */
  hasItem(key: string): boolean {
    return this.getItem(key) !== null;
  }

  /**
   * Remove um valor do LocalStorage de acordo com sua chave.
   *
   * @param key chave sobre a qual o valor deve ser removido
   */
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Limpa todos os valores armazenados no LocalStorage.
   */
  clear(): void {
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api/local-storage.service.ts